// extracted by mini-css-extract-plugin
module.exports = {"title":"ChanelBanner_title__H2bHx","banner":"ChanelBanner_banner__YS5Ud"};